import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { PermissionsResponse } from "../response/PermissionsResponse";

interface usePermissionsProps {
    roleId: number | undefined;
}

export const usePermissions = ({ roleId }: usePermissionsProps) => {
    return useQuery({
        queryKey: ['roles', 'permissions'],
        queryFn: async () => {
            try {
                const response = await privateApi.get('/v3/permission-list');

                const validationResult = PermissionsResponse.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Failed to fetch permissions");
                }
                return validationResult.data;

            } catch (error) {
                console.error("Failed to fetch permissions", error);
                throw error;
            }
        },
        enabled: !!roleId,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};